import React from 'react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const PACKAGE_FIELDS = [
  { name: 'name', label: 'Package Name', required: true, placeholder: 'e.g. Premium Package' },
  {
    name: 'category',
    label: 'Category',
    type: 'select',
    required: true,
    placeholder: 'Select category',
    options: [
      { value: 'glambooth', label: 'Glam Booth' },
      { value: 'photography', label: 'Photography' },
      { value: 'videography', label: 'Videography' },
    ],
  },
  { name: 'duration', label: 'Duration', required: true, placeholder: 'e.g. Up to 3 hours' },
  { name: 'price', label: 'Display Price (AUD)', placeholder: 'e.g. $749' },
  { name: 'base_price', label: 'Base Price (numeric)', type: 'number', help: 'Used by the enquiry calculator, e.g. 749' },
  { name: 'service_key', label: 'Service Key', placeholder: 'glambooth | photography | videography', help: 'Stable key for the enquiry calculator' },
  { name: 'suitable_for', label: 'Suitable For', placeholder: 'e.g. Birthdays, engagements, corporate events' },
  { name: 'turnaround', label: 'Turnaround', placeholder: 'e.g. Full gallery within 14 days' },
  { name: 'delivery', label: 'Delivery Method', placeholder: 'e.g. Private Lightroom gallery' },
  { name: 'features', label: 'Inclusions', type: 'list', help: 'One inclusion per line' },
  { name: 'exclusions', label: 'Exclusions', type: 'list', help: 'One exclusion per line' },
  { name: 'upgrades', label: 'Optional Upgrades', type: 'upgrades', help: 'Add-ons shown on the package + enquiry calculator. "Amount" is the numeric price used for estimates (0 for variable/"from" prices). Tick "Variable" for from/per-hour/per-image prices (quoted separately). Untick "Discountable" for surcharges/travel.' },
  {
    name: 'availability', label: 'Availability', type: 'select',
    options: [
      { value: 'available', label: 'Available' },
      { value: 'unavailable', label: 'Unavailable' },
      { value: 'custom_quote', label: 'Custom quote only' },
    ],
  },
  { name: 'published', label: 'Published', type: 'checkbox', checkboxLabel: 'Show on public site' },
  { name: 'popular', label: 'Most Popular', type: 'checkbox', checkboxLabel: 'Mark as most popular' },
  { name: 'order', label: 'Display Order', type: 'number', help: 'Lower numbers appear first' },
];

const PackagesAdmin = () => (
  <CrudManager
    title="Packages"
    description="Manage your service packages"
    api={adminApi.packages}
    fields={PACKAGE_FIELDS}
    itemLabel="Package"
    groupBy="category"
    renderItem={(pkg) => (
      <div>
        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-[#EADBC8] font-bold">{pkg.name}</h3>
          {pkg.popular && (
            <span className="text-xs bg-[#C5A880] text-[#1F1A17] px-2 py-0.5 rounded-full font-bold">
              POPULAR
            </span>
          )}
        </div>
        <p className="text-[#C5A880] text-sm mb-2">{pkg.price ? `${pkg.price} · ` : ''}{pkg.duration}</p>
        <p className="text-gray-400 text-xs">{pkg.features?.length || 0} features · Order: {pkg.order}</p>
      </div>
    )}
  />
);

export default PackagesAdmin;
